export const formatDate = (value?: string | Date) => {
  if (!value) return 'TBD'
  const date = typeof value === 'string' ? new Date(value) : value
  return date.toLocaleDateString('en-GB', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })
}

export const formatPercentage = (value?: number) => {
  if (value === undefined || Number.isNaN(value)) {
    return '—%'
  }
  return `${Math.round(value)}%`
}

export const formatRelativeTime = (value?: string | Date) => {
  if (!value) return 'unknown'
  const date = typeof value === 'string' ? new Date(value) : value
  const diffMs = date.getTime() - Date.now()
  const minutes = Math.round(diffMs / 60000)
  const hours = Math.round(minutes / 60)
  const days = Math.round(hours / 24)
  if (Math.abs(hours) < 1) {
    return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(minutes, 'minute')
  }
  if (Math.abs(days) < 1) {
    return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(hours, 'hour')
  }
  return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(days, 'day')
}
